'use client';

import { __awaiter, __generator } from '../../_virtual/_tslib.js';
import React__default, { useRef, useImperativeHandle } from 'react';
import Col from '../../LayoutSystem/Col.js';
import Row from '../../LayoutSystem/Row.js';
import Form from '../../Form/index.js';
import Input from '../../Input/index.js';
import CheckBox from '../../CheckBox/index.js';
import { FormWrapper } from '../styled.js';
import { sendMailXaloLead } from '../../services/xaloLead/index.js';
import { ELanguage } from '../../Utils/constants.js';
import { setCookie } from '../../Utils/cookie.js';

function FormRegisterXaloLead(_a, ref) {
    var _this = this;
    var xaloLead = _a.xaloLead, active = _a.active, formData = _a.formData, baseMsUrl = _a.baseMsUrl, _b = _a.langCode, langCode = _b === void 0 ? ELanguage.VI : _b, setIsSuccess = _a.setIsSuccess, user = _a.user;
    var formRef = useRef(null);
    var validator = Form.validator();
    var rules = {
        txtCMBFullName: validator
            .string()
            .require('Thông tin này bắt buộc.')
            .noSpecialChars('Thông tin này bắt buộc.')
            .generate(),
        txtCMBEmail: validator
            .string()
            .require('Thông tin này bắt buộc.')
            .email('Địa chỉ Email không hợp lệ')
            .generate(),
        txtCMBCellphone: validator.string().require('Thông tin này bắt buộc.').generate(),
        txtCMBAddress: validator
            .string()
            .require('Thông tin này bắt buộc.')
            .noSpecialCharsWithoutNumber('Vui lòng không nhập số hoặc ký tự đặc biệt.')
            .generate(),
        txtCMBYearExp: validator.number().require('Thông tin này bắt buộc.').generate(),
        chkCMBAgreeTerm: validator
            .string()
            .custom(function (value) {
            if (value === 'off') {
                return false;
            }
            return true;
        }, 'Thông tin này bắt buộc.')
            .generate()
    };
    var handleSendLead = function (data) { return __awaiter(_this, void 0, void 0, function () {
        var sendLead;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, sendMailXaloLead(baseMsUrl, langCode, data)];
                case 1:
                    sendLead = _a.sent();
                    if (sendLead) {
                        setIsSuccess(true);
                        setCookie('xaloLeadRegistered', String(user.userId), 180);
                    }
                    return [3 /*break*/, 3];
                case 2:
                    _a.sent();
                    console.error();
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var onSubmit = function () {
        var _a;
        (_a = formRef.current) === null || _a === void 0 ? void 0 : _a.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
    };
    useImperativeHandle(ref, function () {
        return {
            onSubmit: onSubmit
        };
    }, [user]);
    return (React__default.createElement(FormWrapper, { xs: 24, activeForm: active },
        React__default.createElement(Form, { ref: formRef, initialValues: formData, onSubmit: function (values) { return handleSendLead(values); } },
            React__default.createElement(Row, { gutter: 8 },
                React__default.createElement(Form.Item, { name: 'txtCMBFullName', rules: rules.txtCMBFullName }, function (field) {
                    return (React__default.createElement(Col, { xs: 24 },
                        React__default.createElement(Input, { placeholder: 'H\u1ECD v\u00E0 t\u00EAn', value: field.value, onChange: field.onChange, onBlur: function () { return field.onBlur(); }, hasError: field.isError, maxLength: 50 }),
                        React__default.createElement(Form.Error, null)));
                }),
                React__default.createElement(Form.Item, { name: 'txtCMBEmail', rules: rules.txtCMBEmail }, function (field) {
                    return (React__default.createElement(Col, { xs: 12 },
                        React__default.createElement(Input, { placeholder: 'Email', value: field.value, onChange: field.onChange, onBlur: function () { return field.onBlur(); }, hasError: field.isError, maxLength: 50 }),
                        React__default.createElement(Form.Error, null)));
                }),
                React__default.createElement(Form.Item, { name: 'txtCMBCellphone', rules: rules.txtCMBCellphone }, function (field) {
                    return (React__default.createElement(Col, { xs: 12 },
                        React__default.createElement(Input, { placeholder: 'S\u1ED1 \u0111i\u1EC7n tho\u1EA1i', value: field.value, onChange: field.onChange, onBlur: function () { return field.onBlur(); }, hasError: field.isError, maxLength: 13 }),
                        React__default.createElement(Form.Error, null)));
                }),
                React__default.createElement(Form.Item, { name: 'txtCMBAddress', rules: rules.txtCMBAddress }, function (field) {
                    return (React__default.createElement(Col, { xs: 12 },
                        React__default.createElement(Input, { placeholder: 'Khu v\u1EF1c', type: 'text', value: field.value, onChange: field.onChange, onBlur: function () { return field.onBlur(); }, hasError: field.isError, maxLength: 50 }),
                        React__default.createElement(Form.Error, null)));
                }),
                React__default.createElement(Form.Item, { name: 'txtCMBYearExp', rules: rules.txtCMBYearExp }, function (field) {
                    return (React__default.createElement(Col, { xs: 12 },
                        React__default.createElement(Input, { placeholder: 'S\u1ED1 tu\u1ED5i', type: 'number', value: field.value, onChange: field.onChange, onBlur: function () { return field.onBlur(); }, hasError: field.isError, maxLength: 3 }),
                        React__default.createElement(Form.Error, null)));
                }),
                React__default.createElement(Form.Item, { name: 'chkCMBAgreeTerm', rules: rules.chkCMBAgreeTerm }, function (field) {
                    var _a;
                    return (React__default.createElement(Col, { xs: 24 },
                        React__default.createElement(CheckBox, { labelRightMargin: 0, customLabel: React__default.createElement("label", { style: { marginLeft: 8 }, dangerouslySetInnerHTML: { __html: (_a = xaloLead === null || xaloLead === void 0 ? void 0 : xaloLead.popupTermsAndCond) !== null && _a !== void 0 ? _a : '' } }), state: field.value === 'on' ? 'checked' : 'none', onCheckChange: function (value) {
                                field.onChange(value === 'checked' ? 'on' : 'off');
                            } }),
                        React__default.createElement(Form.Error, null)));
                })))));
}
var FormRegisterXaloLead$1 = React__default.forwardRef(FormRegisterXaloLead);

export { FormRegisterXaloLead$1 as default };
//# sourceMappingURL=FormRegisterXaloLead.js.map
